<template>
	<article class="push-manage">
		<form @submit.prevent="searching(0)">
			<managing-section class="search-by-enter__container">
				<ManagingBox title="푸시유형">
					<RadioList
						v-model="type"
						:radio-list="typeList"
						input-class="search-by-enter__target"
					/>
				</ManagingBox>
				<managing-box title="푸시내용">
					<input
						class="search-by-enter__target"
						type="text"
						placeholder="푸시내용 검색"
						v-model="notiText"
					/>
				</managing-box>
				<managing-box title="등록기간">
					<DateRange v-model="createdDateRange" type="date" />
				</managing-box>
				<managing-box title="발송일시">
					<DateRange v-model="startDateRange" type="date" />
				</managing-box>
				<managing-box title="상태">
					<RadioList
						v-model="status"
						:radioList="statusList"
						input-class="search-by-enter__target"
					/>
				</managing-box>
			</managing-section>
			<div class="btn-wrap-main">
				<button type="submit" class="btn-main blue" v-text="'검색'" />
				<button
					type="button"
					class="btn-main"
					@click="initFilter"
					v-text="'검색조건 초기화'"
				/>
			</div>
		</form>

		<managing-section :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left">
					검색결과 : {{ contentTotal }}건
				</div>
				<div class="section__info__right">
					<p class="push-manage__table-desc">
						※ 즉시전송은 예약건을 제외한 푸쉬만 보냅니다.
					</p>
				</div>
			</template>
			<table class="table-main push-manage__table" v-if="notiList">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th">{{ th }}</th>
					</tr>
				</thead>
				<tbody v-if="notiList.length < 1">
					<tr>
						<td :colspan="thList.length">검색결과가 없습니다</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr v-for="item in notiList" :key="item.idx">
						<td>{{ item.id }}</td>
						<td>{{ item.createdDate }}</td>
						<td>
							<router-link
								class="link push-manage__link"
								:to="item.link"
								v-html="item.notiText"
							></router-link>
						</td>
						<td>{{ item.registerCnt }}</td>
						<td>{{ item.startDate }}</td>
						<td>{{ item.sentDate }}</td>
						<td>
							{{ item.status }}
							<button
								class="btn push-manage__table__cancel-btn"
								type="button"
								v-if="item.status === '대기'"
								@click="
									cancel(item.idNoti, item.idNotiSchedule)
								"
							>
								취소
							</button>
						</td>
						<td>{{ item.adminNickname }}</td>
						<td>{{ item.isPush }}</td>
						<td>{{ item.isMsgBox }}</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				:total-item="contentTotal"
				:limit="limit"
				:offset="offset"
				:page-leng-per-one="10"
				@to="searching($event.offset)"
				slot="pagination"
			/>
		</managing-section>
	</article>
</template>

<script>
	import isEmpty from 'lodash/isEmpty';
	import isEqual from 'lodash/isEqual';
	import moment from 'moment';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import DateRange from '@/components/DateRange';
	import RadioList from '@/components/RadioList';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';

	export default {
		name: 'PushManage',
		components: {
			ManagingSection,
			ManagingBox,
			DateRange,
			RadioList,
			PaginationBox,
			SearchByEnter,
		},
		extends: SearchByEnter,
		data() {
			return {
				typeList: [
					{ id: null, value: '전체' },
					{ id: 'target', value: '수동푸시' },
					{ id: 'auto', value: '자동푸시' },
				],
				type: null,
				notiText: '',
				createdDateRange: { from: '', to: '' },
				startDateRange: { from: '', to: '' },
				statusList: [
					{ id: null, value: '전체' },
					{ id: 'pending', value: '대기' },
					{ id: 'done', value: '발송완료' },
					{ id: 'cancelled', value: '취소/실패' },
				],
				status: null,
				thList: [
					'푸시 항번',
					'등록일시',
					'푸시 내용',
					'발송대상',
					'예약일시',
					'발송일시',
					'상태',
					'관리자명',
					'푸시전송',
					'알림함 추가',
				],
				notiList: null,
				offset: 0,
				limit: 10,
				contentTotal: 0,
				now: 0,
			};
		},
		mounted() {
			this.setFilter();
			this.searching();
		},
		methods: {
			getPeriodFromQuery(query) {
				if (query) {
					const [from, to] = query.split(',');
					return {
						from:
							from && from !== '0'
								? moment(from, 'X').format('YYYY-MM-DD')
								: '',
						to: to ? moment(to, 'X').format('YYYY-MM-DD') : '',
					};
				} else {
					return { from: '', to: '' };
				}
			},
			setFilter() {
				const query = this.$route.query;
				this.notiText = query.notiText || '';
				this.createdDateRange = this.getPeriodFromQuery(
					query.createdDateRange
				);
				this.startDateRange = this.getPeriodFromQuery(
					query.startDateRange
				);
				this.status = query.status || null;
				this.type = query.type || null;
				this.offset = query.offset ? Number(query.offset) : 0;
			},
			validation() {
				if (this.notiText.length === 1) {
					alert('검색어는 2글자 이상 입력해주세요.');
					return false;
				}
				return true;
			},
			getPeriodParams({ from, to }) {
				return from || to
					? [
							from ? moment(from, 'YYYY-MM-DD').format('X') : 0,
							to
								? moment(to, 'YYYY-MM-DD')
										.endOf('date')
										.format('X')
								: null,
						]
					: null;
			},
			getParams() {
				const params = {
					notiTexts: this.notiText ? this.notiText.split(' ') : null,
					status: this.status,
					type: this.type,
					offset: this.offset,
					limit: this.limit,
				};
				params.createdDateRange = this.getPeriodParams(
					this.createdDateRange
				);
				params.startDateRange = this.getPeriodParams(
					this.startDateRange
				);
				return params;
			},
			listParsing(list) {
				if (!list || list.length < 1) return [];
				const now = this.now / 1000;
				const dateParsing = date =>
					date ? moment(date * 1000).format('YYYY-MM-DD HH:mm') : '-';
				const notiTextParsing = str => {
					return str
						? str
								.split('')
								.reduce((acc, char, idx) => {
									acc.push(char);
									if (Number.isInteger((idx + 1) / 45))
										acc.push('<br>');
									return acc;
								}, [])
								.join('')
						: '';
				};
				const getStatus = (sentDate, startDate, cancelledDate) => {
					const fromStartDate =
						(now - (startDate || sentDate)) / 60 / 60;
					if (cancelledDate) {
						// 취소: cancelledDate is not null
						return '취소';
					} else if (sentDate) {
						// 발송완료: sentDate is not null
						return '발송완료';
					} else if (fromStartDate < 1) {
						// 대기: startDate 로부터 1시간 미만, sentDate가 null 인 경우(대기 상태에서만 취소 가능)
						return '대기';
					} else if (startDate && fromStartDate >= 1) {
						// 발송실패: startDate 로부터 1시간 지났는데, sentDate가 null 인 경우
						return '발송실패';
					} else {
						return '발송중';
					}
				};
				let idNoti;
				let idNotiSchedule;
				let startDate;
				let sentDate;
				return list.map((item, idx) => {
					idNoti = item.idNoti;
					idNotiSchedule = item.idNotiSchedule;
					startDate = item.startDate;
					sentDate = item.sentDate;
					return {
						idx,
						id: `${idNoti}-${idNotiSchedule}`,
						createdDate: dateParsing(item.createdDate),
						link: `/manage/push-inquiry/${idNoti}/${idNotiSchedule}`,
						notiText: notiTextParsing(item.notiText),
						registerCnt:
							item.type === 'all'
								? '전체발송'
								: `${item.registerCnt} 명`,
						startDate: dateParsing(startDate),
						sentDate: dateParsing(sentDate),
						status: getStatus(
							sentDate,
							startDate,
							item.cancelledDate
						),
						idNoti,
						idNotiSchedule,
						adminNickname: item.adminNickname,
						isPush: item.isPush ? 'O' : 'X',
						isMsgBox: item.isMsgBox ? 'O' : 'X',
					};
				});
			},
			setQuery(params) {
				const query = {
					notiText: this.notiText,
					status: this.status,
					type: this.type,
					offset: String(this.offset),
				};
				if (params.createdDateRange) {
					query.createdDateRange = params.createdDateRange.join(',');
				}
				if (params.startDateRange) {
					query.startDateRange = params.startDateRange.join(',');
				}
				if (isEqual(query, this.$route.query)) return;
				this.$router.replace({ query });
			},
			async searching(offset) {
				if (typeof offset === 'number') this.offset = offset;
				try {
					if (!this.validation()) return;
					const params = this.getParams();
					const { data } = await this.$axiosAdmin2.post(
						'/api/noti/list',
						params
					);
					this.contentTotal = data.data.contentTotal;
					this.now = data.now;
					this.notiList = this.listParsing(data.data.data);
					this.setQuery(params);
				} catch (err) {
					console.error(err);
					alert('푸시 검색에 실패했습니다. 개발팀에 문의하세요.');
				}
			},
			initFilter() {
				this.type = null;
				this.notiText = '';
				this.createdDateRange = { from: '', to: '' };
				this.startDateRange = { from: '', to: '' };
				this.status = null;
			},
			async cancel(idNoti, idNotiSchedule) {
				if (!confirm('푸시 발송을 정말 취소하시겠습니까?')) return;
				try {
					const { data } = await this.$axiosAdmin2.delete(
						`/api/noti/${idNoti}/schedule/${idNotiSchedule}`
					);
					alert(
						data.cancelled === 1
							? '푸시 예약발송이 취소되었습니다.'
							: '이미 발송완료되어 예약이 취소되지 않았습니다.'
					);
					window.location.reload();
				} catch (err) {
					console.error(err);
					alert('푸시 취소에 실패했습니다. 개발팀에 문의하세요.');
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.push-manage__table-desc {
		color: $red;
		font-size: 0.875rem;
	}

	.push-manage__table {
		min-width: 768px;

		th,
		td {
			white-space: nowrap;
			text-align: center;
		}
	}

	.push-manage__link {
		font-weight: bold;
		white-space: normal;
		word-wrap: break-word;
		word-break: break-all;
	}

	.push-manage__table__cancel-btn {
		display: block;
		margin: 12px auto 0 auto;
	}
</style>
